import { applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

/* ------------- Redux Configuration ------------- */
const middleware = [thunk];
const enhancers = [window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()];

/* ------------- Assemble Middleware ------------- */
enhancers.push(applyMiddleware(...middleware));

export default enhancers;



// WEBPACK FOOTER //
// ./src/utils/redux.js